__webpack_require__.p = "/joannaPortfolio/";